import { Link } from "react-router";
import Picture, { CARD } from "../Picture/Picture.jsx";
import styles from "./EntryCard.module.css";

const KIND_LABEL = {
  "case-study": "Case study",
  post: "Article",
  webinar: "Webinar",
  project: "Project",
  whitepaper: "Whitepaper",
  press: "Press",
};

const SIZES = {
  default: "(min-width: 64rem) 30vw, (min-width: 48rem) 50vw, 100vw",
  feature: "(min-width: 64rem) 55vw, 100vw",
  compact: "(min-width: 64rem) 16vw, 40vw",
};

/**
 * `variant`: "default" (grid card), "feature" (the big one in a 1 + 2 layout) or
 * "compact" (a thumbnail beside the title, no description).
 */
export default function EntryCard({
  variant = "default",
  kind,
  href,
  image,
  imageAlt,
  title,
  description,
  meta,
  external = false,
}) {
  const label = KIND_LABEL[kind] || kind;
  const Wrapper = external ? "a" : Link;
  const linkProps = external ? { href, rel: "noopener", target: "_blank" } : { to: href };
  const variantClass = variant === "default" ? "" : styles[variant];
  return (
    <article className={`${styles.card} ${variantClass}`.trim()}>
      {image ? (
        <Picture
          src={image}
          alt={imageAlt}
          {...CARD}
          ratio={variant === "compact" ? "4 / 3" : CARD.ratio}
          sizes={SIZES[variant] || SIZES.default}
          className={styles.media}
        />
      ) : (
        <div className={`${styles.media} ${styles.placeholder}`} aria-hidden="true">
          <span>{label}</span>
        </div>
      )}
      <div className={styles.body}>
        <p className={styles.kindRow}>
          <span className={styles.kind}>{label}</span>
          {meta ? <span className={styles.meta}>{meta}</span> : null}
        </p>
        <h3 className={styles.title}>
          <Wrapper {...linkProps} className={styles.link}>
            {title}
          </Wrapper>
        </h3>
        {description && variant !== "compact" ? (
          <p className={styles.description}>{description}</p>
        ) : null}
      </div>
    </article>
  );
}
